// @flow

import React, {Component} from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import I18n from 'PMT/i18n/I18n'

import ArrayUtils from 'PMT/utils/ArrayUtils'

// -- utils
import { StringUtils } from 'PMT/utils'

// -- entities
import CategoryItem from 'PMT/entities/menu/CategoryItem'
import RestaurantMenu from 'PMT/entities/menu/RestaurantMenu'

// -- views
import SubmitArea from 'PMT/components/form/SubmitArea'
import { Tabs, Tab } from 'react-bootstrap'
import ItemTabView from './ItemTabView'

class ItemSelectorView extends Component {

  static defaultProps = {
    values: [],
    options: [],
  }

  static propTypes = {
    restaurantMenu: PropTypes.instanceOf(RestaurantMenu).isRequired,
    options: PropTypes.array.isRequired,
    values: PropTypes.array.isRequired,
    onChange: PropTypes.func.isRequired,
  }

  state = {
    tab: null,
    values: _.clone(this.props.values),
  }

  haveModifications(): boolean {
    return !_.isEqual(this.props.values, this.state.values)
  }

  onTabChange = (tab) => {
    this.setState({
      tab,
    })
  }

  getValuesFor = (categoryItemType) => {
    return this.state.values.filter((value) => (
      value.type === categoryItemType
    ))
  }

  getOptionsFor = (categoryItemType) => {
    const options = this.props.options.filter((option) => (
      option.type === categoryItemType
    ))

    // will contains the items from the restaurantMenu
    let menuItems = []

    if (categoryItemType === CategoryItem.Type.CATEGORY) {
      menuItems = this.props.restaurantMenu.categories
    } else if (categoryItemType === CategoryItem.Type.MENU) {
      menuItems = this.props.restaurantMenu.menus
    } else if (categoryItemType === CategoryItem.Type.PRODUCT) {
      menuItems = this.props.restaurantMenu.products
    }

    // TODO: keep only the items on options array

    return menuItems
  }

  onToggleItem = (item, categoryItemType) => {
    let values = this.state.values

    // item is the restaurantMenu object, we transform it in a categoryItem
    const categoryItem = {
      id: item.id,
      type: categoryItemType,
    }

    values = ArrayUtils.toggleObject(
      values,
      categoryItem,
      (i) => i.id === categoryItem.id && i.type === categoryItem.type
    )
    this.setState({
      values,
    })
  }

  // -- form
  onSubmit = () => {
    this.props.onChange(this.state.values)
  }

  onReset = () => {
    this.setState({
      values: _.clone(this.props.values),
    })
  }

  //
  //
  //

  renderSubmitArea() {
    return (
      <div
        style={{
          marginTop: '30px',
          textAlign: 'center',
        }}
      >
        <SubmitArea
          haveModifications={this.haveModifications()}
          onSubmit={this.onSubmit}
          onReset={this.onReset}
        />
      </div>
    )
  }

  render() {
    return (
      <div>
        <Tabs
          defaultValue={this.state.tab}
          onSelect={this.onTabChange}
          id="item_selector_tabs"
        >

          <Tab
            eventKey={1}
            title={I18n.tr('menu.category.categories')}
          >
            <div className="top-buffer-30">
              <ItemTabView
                restaurantMenu={this.props.restaurantMenu}
                options={this.getOptionsFor(CategoryItem.Type.CATEGORY)}
                values={this.getValuesFor(CategoryItem.Type.CATEGORY)}
                onToggleItem={(item) => this.onToggleItem(item, CategoryItem.Type.CATEGORY)}
              />
            </div>
          </Tab>

          <Tab
            eventKey={2}
            title={I18n.tr('menu.category.products')}
          >
            <div className="top-buffer-30">
              <ItemTabView
                restaurantMenu={this.props.restaurantMenu}
                options={this.getOptionsFor(CategoryItem.Type.PRODUCT)}
                values={this.getValuesFor(CategoryItem.Type.PRODUCT)}
                onToggleItem={(item) => this.onToggleItem(item, CategoryItem.Type.PRODUCT)}
              />
            </div>
          </Tab>

          <Tab
            eventKey={3}
            title={I18n.tr('menu.category.menus')}
          >
            <div className="top-buffer-30">
              <ItemTabView
                restaurantMenu={this.props.restaurantMenu}
                options={this.getOptionsFor(CategoryItem.Type.MENU)}
                values={this.getValuesFor(CategoryItem.Type.MENU)}
                onToggleItem={(item) => this.onToggleItem(item, CategoryItem.Type.MENU)}
              />
            </div>
          </Tab>

        </Tabs>

        {this.renderSubmitArea()}
      </div>
    )
  }

}

export default ItemSelectorView
